import { ControlCenter } from "../../shared/components/control-center/ControlCenter";
import { Backdrop, Container } from "./Portal.Parts";

export const Portal = () => (
  <Container>
    <Backdrop $image="https://assets.studio.massivemusic.com/statics/studio-default-background" />
    <ControlCenter />
  </Container>
);
